function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 0.25C4.16797 0.25 0.25 4.16797 0.25 9C0.25 13.832 4.16797 17.75 9 17.75C13.832 17.75 17.75 13.832 17.75 9C17.75 4.16797 13.832 0.25 9 0.25ZM12.2305 12.3242L10.9414 12.3184L9 10.0039L7.06055 12.3164L5.76953 12.3223C5.68359 12.3223 5.61328 12.2539 5.61328 12.166C5.61328 12.1289 5.62695 12.0938 5.65039 12.0645L8.19141 9.03711L5.65039 6.01172C5.62679 5.98309 5.61369 5.94725 5.61328 5.91016C5.61328 5.82422 5.68359 5.75391 5.76953 5.75391L7.06055 5.75977L9 8.07422L10.9395 5.76172L12.2285 5.75586C12.3145 5.75586 12.3848 5.82422 12.3848 5.91211C12.3848 5.94922 12.3711 5.98438 12.3477 6.01367L9.81055 9.03906L12.3496 12.0664C12.373 12.0957 12.3867 12.1309 12.3867 12.168C12.3867 12.2539 12.3164 12.3242 12.2305 12.3242Z",
  fill: "#A6A3B1"
});

var SvgCloseCircle = function SvgCloseCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/closeCircle.ddd7c90a.svg";
export { ForwardRef as ReactComponent };